<template>
  <tr>
    <td>
      {{win_bet.event_name}}
    </td>
    <td>
      {{win_bet.user_name}}
    </td>
    <td>
      {{win_bet.date}}
    </td>
    <td>
      {{win_bet.comments}}
    </td>

  </tr>
</template>

<script>
export default {
  name: 'WinLoxBet',
  props: ['win_bet'],
  data() {
    return {

    }
  },
  methods:
    {
    }
}
</script>